import { useEffect, useState, useRef } from 'react'
import Form from 'react-bootstrap/Form';
import { toast } from 'react-toastify';

export default function ButtonUploadControl(props) {

	const inputRef = useRef(null);
	
    function onFileChange (event) {
		
		/*if(props.size && event.target.files[0].size/1000 > props.size) {
			toast.error('حداکثر سایز فایل باید '+props.size/1000+' مگابایت باشد.');
			props.inputRef.current.value = null;
            return false;			
		}*/
		
        if (event.target.files[0].name.toLowerCase().match(props.fileType) == null) {			
			toast.error('فرمت فایل باید ' + props.fileType.toString().replace('/','').replace('/','') + ' باشد.');
			props.inputRef.current.value = null;
            return false;
        }
		
		   var reader = new FileReader();
		   reader.readAsDataURL(event.target.files[0]);
		   reader.onload = function () {
			   let type = ((reader.result.split('base64,')[0]).split("/")[1]).replace(';','');
			   props.onChangeFile(type, reader.result.split('base64,')[1],reader.result.split('base64,')[1]);
		   };
		   reader.onerror = function (error) {
			   props.onChangeFile(error);
		   };
    };	

    return (
            <div
                key={new Date().getSeconds()}
            >
                <input
                    type="file"
                    ref={props.inputRef}
					style={{border: '1px solid #ccc', padding: '7px'}}
					className={props.className}
					required={props.required}
					onChange={(e) => onFileChange(e)}
                    accept={props.accept == undefined ? '*' : props.accept}
                />
            </div>
    )
}